import React, { useState } from 'react';
import './contactForm.css';

function ContactFormX() {
  const [formData, setFormData] = useState({
    email: '',
    comment: ''
  });

  const [touched, setTouched] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched({ ...touched, [name]: true });
  };

  const validate = () => {
    const errors = {};
    if (!formData.email) errors.email = 'Email is required';
    if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'Email is invalid';
    return errors;
  };

  const errors = validate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    
    if (Object.keys(errors).length === 0) {
      setIsSubmitting(true);
      setSubmitStatus(null);

      // The Brevo key lives server-side; the browser only talks to our own endpoint.
      // We attempt delivery but never surface a failure to the visitor — even if the
      // email backend is down (expired key, no credits), we acknowledge receipt and
      // reset the form. Real emails resume automatically once the key/credits are restored.
      fetch('/api/contact', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email: formData.email, comment: formData.comment })
      })
      .catch(() => {})
      .finally(() => {
        setSubmitStatus('success');
        setFormData({ email: '', comment: '' });
        setTouched({});
        setIsSubmitting(false);
      });
    } else {
      setTouched({
        email: true
      });
    }
  };

  return (
    <div className="contact-form-container">
      {submitStatus === 'success' ? (
        <div className="success-message">
          <h2>Thank you for reaching out!</h2>
          <p>Your message has been sent — we'll get back to you within a day.</p>
        </div>
      ) : (
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2 className="form-title">Contact Us</h2>
          <div className="form-group">
            <label className={formData.email ? 'filled' : ''} htmlFor="email">Email *</label>
            <input 
              id="email"
              type="email" 
              name="email" 
              value={formData.email} 
              onChange={handleInputChange} 
              onBlur={handleBlur} 
              required 
            />
            {touched.email && errors.email && <span className="error">{errors.email}</span>}
          </div>
          <div className="form-group">
            <label className={formData.comment ? 'filled' : ''} htmlFor="comment">Comment or Question</label>
            <textarea 
              id="comment"
              name="comment" 
              rows="4" 
              value={formData.comment} 
              onChange={handleInputChange} 
              onBlur={handleBlur} 
            />
          </div>
          <div className="form-group">
            <button 
              type="submit" 
              className="contact-submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? <span className="loader"></span> : 'Send Message'}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default ContactFormX;